import { Typography, Container, Paper } from "@mui/material"
import { motion, useInView } from "framer-motion"
import { useRef } from "react"
import ContactForm from "./ContactForm"

export default function Contact() {

    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    return (
        <Container
            ref={ref}
            component={motion.div}
            sx={{ my: { xs: "15vh", xl: "30vh" } }}
            maxWidth="lg"
            id="contact">
            <Paper component={motion.div}
                sx={{ p: 3 }}
                initial={{ y: 1500 }}
                animate={isInView ? { y: 0 } : "none"}
                transition={{ type: "spring" }}
            >
                <Typography
                    component={motion.h2}
                    variant="h2"
                    initial={{ opacity: 0 }}
                    transition={{ delay: 0.5, duration: 1 }}
                    animate={isInView ? { opacity: 1 } : "none"}
                    color="primary"
                    align="center"
                    sx={{ pb: 5 }}
                >
                    ContAct
                </Typography>
                <ContactForm isInView={isInView} />
            </Paper>
            <Typography sx={{ my: "5vh" }} color="secondary" align="center">&copy; 2023 Kord Maurer</Typography>
        </Container>
    )
}